import { PatientAssessmentControllerXApi } from "../../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../../utils/utils";

interface AssignForReviewParams {
  assessmentId: string;
  providerId: string;
}

export const useAssignForReview = () =>
  useMutationWithLoading(async (param: AssignForReviewParams) =>
    new PatientAssessmentControllerXApi(getConfigObject()).assignForReview(
      param.assessmentId,
      param.providerId,
      getXtenantId()
    )
  );
